import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  Container, Typography, Box, Card, CardContent, Grid,
  Chip, Button, CircularProgress
} from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import logisticsService from '../../services/logistics.service';
import { TZ } from '../../utils/date';

const statusColors = {
  pending: 'warning', assigned: 'info', picked_up: 'primary',
  in_transit: 'primary', delivered: 'success', cancelled: 'error'
};

const LogisticsOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    logisticsService.getMyOrders()
      .then(data => setOrders(data.orders || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh"><CircularProgress /></Box>;

  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4, mb: 4 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h3" fontWeight={700}>Mes envois</Typography>
          <Button component={Link} to="/logistics" variant="contained" startIcon={<LocalShippingIcon />}>
            Nouvel envoi
          </Button>
        </Box>
      </Box>

      {orders.length === 0 ? (
        <Card><CardContent sx={{ textAlign: 'center', py: 6 }}>
          <LocalShippingIcon sx={{ fontSize: 80, color: 'text.secondary', mb: 2 }} />
          <Typography variant="h6" color="text.secondary" gutterBottom>Aucun envoi</Typography>
          <Button component={Link} to="/logistics" variant="contained">Créer un envoi</Button>
        </CardContent></Card>
      ) : (
        <Grid container spacing={3}>
          {orders.map((order) => (
            <Grid item xs={12} key={order.id}>
              <Card>
                <CardContent>
                  <Box display="flex" justifyContent="space-between" mb={2}>
                    <Box>
                      <Typography variant="h6">Colis #{order.tracking_number}</Typography>
                      <Typography variant="caption" color="text.secondary">
                        {new Date(order.created_at).toLocaleDateString('fr-FR', { timeZone: TZ })}
                      </Typography>
                    </Box>
                    <Chip label={order.order_status} color={statusColors[order.order_status] || 'default'} />
                  </Box>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body2" color="text.secondary">De:</Typography>
                      <Typography>{order.pickup_contact_name}</Typography>
                      <Typography variant="body2">{order.pickup_address}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body2" color="text.secondary">À:</Typography>
                      <Typography>{order.delivery_contact_name}</Typography>
                      <Typography variant="body2">{order.delivery_address}</Typography>
                    </Grid>
                  </Grid>
                  <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                    <Typography variant="h6" color="primary">{order.estimated_cost} €</Typography>
                    <Button component={Link} to={`/logistics/track/${order.tracking_number}`} size="small">
                      Suivre
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </Container>
  );
};

export default LogisticsOrders;
